import { render, staticRenderFns } from "./ForestPage.vue?vue&type=template&id=5f0bccfe&scoped=true&"
import script from "./ForestPage.vue?vue&type=script&lang=ts&"
export * from "./ForestPage.vue?vue&type=script&lang=ts&"
import style0 from "./ForestPage.vue?vue&type=style&index=0&id=5f0bccfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0bccfe",
  null
  
)

export default component.exports